/* istanbul ignore file */
import React, { ReactNode } from 'react';
import useFeatureToggleService from 'feature-toggle';
import ErrorsWrapper from './ErrorsWrapper';

import styles from './RadioButtonLayout.module.scss';
import { RadioButtonLayoutProps } from 'ui-builder';
import ShadcnRadioButtonLayout from './ShadcnRadioButtonLayout';

function Hint(props: { hint: ReactNode }) {
  return (
    <div className={styles.hint}>{props.hint}</div>
  );
}

function LegacyRadioButtonLayout(props: RadioButtonLayoutProps) {
  return (
    <ErrorsWrapper name={`${props.name}-${props.groupValue}`} errors={props.errors}>
      <>
        <label
          htmlFor={`${props.name}-${props.groupValue}`}
          className={`${styles.formControl} ${props.isDisabled ? styles.disabled : ''}`}
          title={props.title}
        >
          <input
            value={props.groupValue || ''}
            type="radio"
            id={`${props.name}-${props.groupValue}`}
            checked={props.value || false}
            onChange={props.onChangeCallback}
            name={`${props.name}-${props.groupValue}`}
            disabled={props.isDisabled}
          />
          {!props.hideLabel && props.label}
        </label>
        {props.hint && (<Hint hint={props.hint} />)}
      </>
    </ErrorsWrapper>
  );
}

function RadioButtonLayout(props: RadioButtonLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnRadioButtonLayout {...props} />;
  } else {
    return <LegacyRadioButtonLayout {...props} />;
  }
}

export default RadioButtonLayout;
